var exports = {
  "zr": "x93eb46d8--6f5750--root",
  "O0": "x93eb46d8--6f5750--rating",
  "Pu": "x93eb46d8--6f5750--rating_with-dot",
};

module.exports = exports;
